/**
 * The tag a new name would collide with, or `undefined`. Case-insensitive, and the tag being renamed
 * is excluded so "biz" → "Biz" stays a case fix. This is the ONLY guard: the backend merges silently
 * on a rename onto an existing name and never answers 409, so a request sent past it cannot be undone.
 * Used twice: the dialog's instant pre-check (against the list on screen) and `useRenameTag`, against
 * a list fetched immediately before the PATCH.
 */
export function collidingTag(tags: readonly string[], from: string, to: string): string | undefined {
  const lower = to.toLowerCase()
  return tags.find((t) => t !== from && t.toLowerCase() === lower)
}

/** Thrown before any request is sent: a fresh tag list already holds `existing`. */
export class TagNameTakenError extends Error {
  readonly existing: string
  constructor(existing: string) {
    super('tag-name-taken')
    this.name = 'TagNameTakenError'
    this.existing = existing
  }
}
